import React from "react";

const VideoCameraStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 5.5H11.2941C11.5703 5.5 11.7941 5.72386 11.7941 6V14C11.7941 14.2761 11.5703 14.5 11.2941 14.5H4C3.72386 14.5 3.5 14.2761 3.5 14V6C3.5 5.72386 3.72386 5.5 4 5.5ZM2 6C2 4.89543 2.89543 4 4 4H11.2941C12.3987 4 13.2941 4.89543 13.2941 6V7L16.4624 4.98019C17.1281 4.55582 18 5.03397 18 5.82342V14.1766C18 14.966 17.1281 15.4442 16.4624 15.0198L13.2941 13V14C13.2941 15.1046 12.3987 16 11.2941 16H4C2.89543 16 2 15.1046 2 14V6ZM13.8529 11.5774V8.42263L16.5 6.73513V13.2649L13.8529 11.5774Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(VideoCameraStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;